import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { Select } from 'antd';
// Local deps
import './RFFSelect.scss';
// import RFFRadio from './index';

const Option = Select.Option;

function RFFSelectField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  options,
  changeSelectValue,
  mode,
  defaultValue,
  ...otherProps
}) {
  const _OnChange = value => {
    if (changeSelectValue) {
      changeSelectValue(input, value);
    } else {
      input.onChange(value);

    }
  };

  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <Select
            className="nf-rff-input-field__input"

            {...input}
            {...otherProps}
            onChange={_OnChange}
          >
            {options.map(option => (
              <Option value={option.value} key={option.value} >
                {option.text}
              </Option>
            ))}
          </Select>
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
    </div>
  );
}

RFFSelectField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
};

RFFSelectField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
  changeSelectValue: PropTypes.func.isRequired,
};

export default RFFSelectField;



// WEBPACK FOOTER //
// ./src/components/form/RFFSelect/RFFSelect.jsx